import React from 'react';
export function BottomCTASection() {
  return <div className="text-center bg-gray-50 rounded-2xl p-12 border border-gray-200" data-id="element-1074">
      <h3 className="text-2xl font-bold text-navy mb-8" data-id="element-1075">
        Ready to learn more about Breton Genesi?
      </h3>
      <div className="flex flex-col sm:flex-row justify-center items-center gap-6" data-id="element-1076">
        <a href="https://www.peakedm.com/ContactPeakMachineSales.html?i515589:default[Product%20Title]=Breton%20Genesi%20LSAM" target="_blank" rel="noopener noreferrer" className="text-[#9B0137] hover:text-orange transition-colors font-bold uppercase text-lg tracking-wide flex items-center" data-id="element-1077">
          <span className="mr-2" data-id="element-1078">+</span> REQUEST Brochure / QUOTE
        </a>
        <a href="https://www.breton.it/en/machine-tools/genesi-the-3d-printer-for-the-large-scale-addivitive-manufacturing" target="_blank" rel="noopener noreferrer" className="text-[#9B0137] hover:text-orange transition-colors font-bold uppercase text-lg tracking-wide flex items-center" data-id="element-1079">
          <span className="mr-2" data-id="element-1080">+</span> ADDITIONAL INFORMATION
        </a>
      </div>
    </div>;
}